import { Box, Radio, Slider, styled, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconLayoutSpeaker, IconLayoutTile, IconLayoutTile2, IconTypeFocus } from '../../../base/icons/svg';
import Dialog from '../../../base/ui/components/web/Dialog';
import { COMMANDS } from '../../../mod-command/constants';
import { getModCommand } from '../../../mod-command/functions';
import { sendCommand } from '../../../mod-command/slice';
const LAYOUTS = {
    MAIN_SPEAKER: 'main-speaker-view',
    FOCUS: 'focus-view',
    TILE_VIEW: 'tile-view'
};
const TileSlider = styled(Slider)({
    color: '#EE0033',
    width: '68%',
    margin: '18px 0',
    height: 1,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 12,
        width: 12,
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#EE0033',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
});
const useStyles = makeStyles()(theme => {
    return {
        desc: {
            fontFamily: 'Sarabun, Tahoma, Arial',
            fontWeight: 500,
            fontSize: '16px',
            color: '#44494D',
            margin: '0 0 16px 0'
        },
        itemLayout: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '3px 10px 3px 0',
            '&:hover': {
                backgroundColor: theme.palette.bgParticipantHover,
                borderRadius: '6px',
                cursor: 'pointer',
            }
        },
        itemLayoutButton: {
            display: 'flex',
            alignItems: 'center',
        },
        textItemLayout: {
            fontSize: 16,
            marginLeft: '12px',
            fontFamily: 'Sarabun'
        }
    };
});
const marks = [
    {
        value: 3,
        label: '2x2',
    },
    {
        value: 8,
        label: '3x3',
    },
    {
        value: 15,
        label: '4x4',
    },
    {
        value: 24,
        label: '5x5',
    },
];
function valuetext(value) {
    return `${value}`;
}
function valueLabelFormat(value) {
    return value + 1;
}
const LayoutDialog = ({ exclude, }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const state = useSelector((state) => state);
    const { classes, cx } = useStyles();
    const [valueTile, setValueTile] = useState((parseInt(`${getModCommand(state, COMMANDS.CHANGE_CELLS_DISPLAY.COMMANDS)?.value}`) || 16) - 1);
    const [layout, setLayout] = useState(`${getModCommand(state, COMMANDS.CHANGE_VIEW.COMMANDS)?.value || LAYOUTS.MAIN_SPEAKER}`);
    const handleChangeTileViewValue = (value) => {
        setValueTile(value);
    };
    const onSubmit = () => {
        switch (layout) {
            case LAYOUTS.MAIN_SPEAKER:
                dispatch(sendCommand(COMMANDS.CHANGE_VIEW.COMMANDS, COMMANDS.CHANGE_VIEW.MAIN_SPEAKER, true));
                dispatch(sendCommand(COMMANDS.CHANGE_CELLS_DISPLAY.COMMANDS, 16, true));
                break;
            case LAYOUTS.FOCUS:
                dispatch(sendCommand(COMMANDS.CHANGE_VIEW.COMMANDS, COMMANDS.CHANGE_VIEW.FOCUS, true));
                dispatch(sendCommand(COMMANDS.CHANGE_CELLS_DISPLAY.COMMANDS, 16, true));
                break;
            case LAYOUTS.TILE_VIEW:
                dispatch(sendCommand(COMMANDS.CHANGE_VIEW.COMMANDS, COMMANDS.CHANGE_VIEW.TILE, true));
                dispatch(sendCommand(COMMANDS.CHANGE_CELLS_DISPLAY.COMMANDS, valueTile + 1, true));
                break;
            default:
                break;
        }
    };
    return (React.createElement(Dialog, { ok: { translationKey: 'dialog.layout.save' }, onSubmit: onSubmit, title: t('dialog.layout.title'), size: 'medium-large' },
        React.createElement(Box, { sx: { overflowY: 'hidden' } },
            React.createElement(Box, { className: classes.desc }, t('dialog.layout.desc')),
            React.createElement(Box, { className: classes.itemLayout, onClick: () => setLayout(LAYOUTS.MAIN_SPEAKER) },
                React.createElement(Box, { className: classes.itemLayoutButton },
                    React.createElement(Radio, { checked: layout == LAYOUTS.MAIN_SPEAKER, name: "radio-buttons", onChange: () => setLayout(LAYOUTS.MAIN_SPEAKER) }),
                    React.createElement(Typography, { className: classes.textItemLayout }, t('dialog.layout.speakerView'))),
                React.createElement(Icon, { src: IconLayoutSpeaker, size: 28 })),
            React.createElement(Box, { className: classes.itemLayout, onClick: () => setLayout(LAYOUTS.FOCUS) },
                React.createElement(Box, { className: classes.itemLayoutButton },
                    React.createElement(Radio, { checked: layout == LAYOUTS.FOCUS, name: "radio-buttons", onChange: () => setLayout(LAYOUTS.FOCUS) }),
                    React.createElement(Typography, { className: classes.textItemLayout }, t('dialog.layout.focus'))),
                React.createElement(Icon, { src: IconTypeFocus, size: 28 })),
            React.createElement(Box, { className: classes.itemLayout, onClick: () => setLayout(LAYOUTS.TILE_VIEW) },
                React.createElement(Box, { className: classes.itemLayoutButton },
                    React.createElement(Radio, { checked: layout == LAYOUTS.TILE_VIEW, name: "radio-buttons", onChange: () => setLayout(LAYOUTS.TILE_VIEW) }),
                    React.createElement(Typography, { className: classes.textItemLayout }, t('dialog.layout.tileView'))),
                React.createElement(Icon, { src: IconLayoutTile, size: 28 })),
            React.createElement(Box, { className: "choose-total-tileview" },
                React.createElement(Typography, { sx: { fontSize: 16, fontFamily: 'Sarabun' } }, t('dialog.layout.number')),
                React.createElement(Box, { className: "select-total-tileview", sx: { display: 'flex', justifyContent: "space-around", alignItems: 'center' } },
                    React.createElement(Icon, { src: IconLayoutTile, size: 24 }),
                    React.createElement(TileSlider, { "aria-label": "Restricted values", defaultValue: valueTile, min: 3, max: 24, valueLabelFormat: valueLabelFormat, getAriaValueText: valuetext, step: null, valueLabelDisplay: "auto", marks: marks, disabled: layout == LAYOUTS.TILE_VIEW ? false : true, onChange: (e, newValue) => { handleChangeTileViewValue(newValue); } }),
                    React.createElement(Icon, { src: IconLayoutTile2, size: 24 }))))));
};
export default LayoutDialog;
